import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

function resizeTextarea(textarea) {
  if (!textarea) return;

  textarea.style.height = 'auto';
  textarea.style.height = `${textarea.scrollHeight}px`;
}

export default function SplitDescriptionTextarea({
  value,
  onChange,
  onFocus,
  onBlur,
  className,
}) {
  const textareaRef = useRef(null);

  useEffect(() => {
    resizeTextarea(textareaRef.current);
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      rows={1}
      value={value}
      onChange={(e) => {
        onChange(e);
        resizeTextarea(e.target);
      }}
      onFocus={onFocus}
      onBlur={onBlur}
      className={`w-full resize-none overflow-hidden px-1.5 py-2 text-left text-gray-700 leading-5 border-b rounded-md border-gray-300 focus:outline-none focus:border-brandBlue-400 ${className}`}
    />
  );
}

SplitDescriptionTextarea.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.string,
};

SplitDescriptionTextarea.defaultProps = {
  value: '',
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  className: '',
};
